import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from "@/components/ui/pagination";
import { useState } from "react";

interface InventoryGridProps {
  currentItems: any[];
  handleItemClick: (item: any) => void;
  inventoryData: any[];
  totalPages: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

export const InventoryGrid = ({
  currentItems,
  handleItemClick,
  inventoryData,
  totalPages,
  currentPage,
  setCurrentPage,
}: InventoryGridProps) => {
  return (
    <>
      <Card className="p-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {currentItems.map((item) => {
            const counted = inventoryData.find(d => d.itemId === item.id);
            return (
              <div
                key={item.id}
                className={`p-4 border rounded-lg cursor-pointer hover:bg-gray-50 ${
                  counted ? 'border-green-500 bg-green-50' : ''
                }`}
                onClick={() => handleItemClick(item)}
              >
                <h3 className="font-medium">{item.data.name}</h3>
                <p className="text-sm text-gray-500">
                  Système: {item.quantity} {item.data.unit || 'unités'}
                </p>
                {counted && (
                  <p className="text-sm text-green-600">
                    Compté: {counted.countedQuantity}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </Card>

      {totalPages > 1 && (
        <div className="flex justify-center mt-4">
          <Pagination>
            <PaginationContent>
              <PaginationItem>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                >
                  <PaginationPrevious />
                </Button>
              </PaginationItem>
              
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <PaginationItem key={page}>
                  <Button
                    variant={currentPage === page ? "default" : "ghost"}
                    size="sm"
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Button>
                </PaginationItem>
              ))}

              <PaginationItem>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                >
                  <PaginationNext />
                </Button>
              </PaginationItem>
            </PaginationContent>
          </Pagination>
        </div>
      )}
    </>
  );
};